/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MeetingTemplate = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MeetingTemplate model module.
   * @module model/MeetingTemplate
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MeetingTemplate</code>.
   * @alias module:model/MeetingTemplate
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>MeetingTemplate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MeetingTemplate} obj Optional instance to populate.
   * @return {module:model/MeetingTemplate} The populated <code>MeetingTemplate</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('OrganizerID')) {
        obj['OrganizerID'] = ApiClient.convertToType(data['OrganizerID'], 'Integer');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('FunctionID')) {
        obj['FunctionID'] = ApiClient.convertToType(data['FunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('InvitationOffset')) {
        obj['InvitationOffset'] = ApiClient.convertToType(data['InvitationOffset'], 'Integer');
      }
      if (data.hasOwnProperty('InvitationPeriodTypeID')) {
        obj['InvitationPeriodTypeID'] = ApiClient.convertToType(data['InvitationPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('StartFromLastFollowUps')) {
        obj['StartFromLastFollowUps'] = ApiClient.convertToType(data['StartFromLastFollowUps'], 'Boolean');
      }
      if (data.hasOwnProperty('FollowUpsSectionDuration')) {
        obj['FollowUpsSectionDuration'] = ApiClient.convertToType(data['FollowUpsSectionDuration'], 'Integer');
      }
      if (data.hasOwnProperty('ReminderSendDate')) {
        obj['ReminderSendDate'] = ApiClient.convertToType(data['ReminderSendDate'], 'Date');
      }
      if (data.hasOwnProperty('PromoteInAgendaHome')) {
        obj['PromoteInAgendaHome'] = ApiClient.convertToType(data['PromoteInAgendaHome'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {Integer} OrganizerID
   * @default 0
   */
  exports.prototype['OrganizerID'] = 0;
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {Integer} FunctionID
   * @default 0
   */
  exports.prototype['FunctionID'] = 0;
  /**
   * @member {Integer} InvitationOffset
   * @default 0
   */
  exports.prototype['InvitationOffset'] = 0;
  /**
   * @member {Integer} InvitationPeriodTypeID
   * @default 0
   */
  exports.prototype['InvitationPeriodTypeID'] = 0;
  /**
   * @member {Boolean} StartFromLastFollowUps
   * @default false
   */
  exports.prototype['StartFromLastFollowUps'] = false;
  /**
   * @member {Integer} FollowUpsSectionDuration
   * @default 0
   */
  exports.prototype['FollowUpsSectionDuration'] = 0;
  /**
   * @member {Date} ReminderSendDate
   */
  exports.prototype['ReminderSendDate'] = undefined;
  /**
   * @member {Boolean} PromoteInAgendaHome
   * @default false
   */
  exports.prototype['PromoteInAgendaHome'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


